import * as React from 'react';
import { useHistory } from 'react-router-dom';
import Avatar from 'antd/lib/avatar';
import Dropdown from 'antd/lib/dropdown';
import { LineChartOutlined, SettingOutlined } from '@ant-design/icons';
import { getNavBorderContainerStyle } from '../../styles/globalStyles';
import { useSidebarColors } from '../../styles/themeMode';
import { createOrgRoute, createOrgSettingsRoute } from '../../../helpers/routeHelpers';
import { OrgSettingsTabType } from '../../../typescriptHelpers';
import InviteTeamModal from '../../inviteTeam/InviteTeamModal';
import { DropdownButtonContent } from './DropdownButtonContent';
import { NavigationSegmented } from '../shared/components';

export interface OrgNavigationHeaderProps {
    orgId: string;
    orgIdParam: string;
    orgName: string;
    orgImageUrl?: string;
    isOrgRoute?: boolean;
    isOrgSettingsRoute?: boolean;
    isMainDropdownOpen: boolean;
    onMainDropdownOpenChange: (open: boolean) => void;
    renderProductDropdown: () => React.ReactNode;
    showInviteModal: boolean;
    onInviteModalClose: () => void;
}

export const OrgNavigationHeader: React.FC<OrgNavigationHeaderProps> = ({
    orgId,
    orgIdParam,
    orgName,
    orgImageUrl,
    isOrgRoute,
    isOrgSettingsRoute,
    isMainDropdownOpen,
    onMainDropdownOpenChange,
    renderProductDropdown,
    showInviteModal,
    onInviteModalClose,
}) => {
    const history = useHistory();
    const sc = useSidebarColors();

    const orgLetter = orgName?.charAt(0).toUpperCase() || 'O';
    const activeOrgTab = isOrgSettingsRoute ? 'settings' : 'overview';

    const handleOrgTabChange = (value: string | number) => {
        if (value === 'settings') {
            history.push(createOrgSettingsRoute(orgIdParam, OrgSettingsTabType.Team));
        } else {
            history.push(createOrgRoute(orgIdParam));
        }
    };

    return (
        <div style={{ backgroundColor: sc.bg, padding: '8px', paddingBottom: 0 }}>
            <div style={getNavBorderContainerStyle(sc)}>
                <Dropdown
                    open={isMainDropdownOpen}
                    onOpenChange={onMainDropdownOpenChange}
                    dropdownRender={renderProductDropdown}
                    trigger={['click']}
                >
                    <div>
                        <DropdownButtonContent
                            icon={
                                <Avatar size={30} src={orgImageUrl} style={{ flexShrink: 0 }}>
                                    {orgLetter}
                                </Avatar>
                            }
                            text={orgName}
                            showCaret
                            textStyle={{ fontWeight: 600 }}
                        />
                    </div>
                </Dropdown>
            </div>

            {isOrgRoute && (
                <div style={{ padding: '20px 0' }}>
                    <NavigationSegmented
                        value={activeOrgTab}
                        onChange={handleOrgTabChange}
                        options={[
                            {
                                value: 'overview',
                                icon: <LineChartOutlined />,
                                label: 'Overview',
                            },
                            {
                                value: 'settings',
                                icon: <SettingOutlined />,
                                label: 'Settings',
                            },
                        ]}
                    />
                </div>
            )}

            <InviteTeamModal orgId={orgId} open={showInviteModal} onCancel={onInviteModalClose} />
        </div>
    );
};
